export const DataSourceQcFieldName = 'dataSourceQcFieldComponent';
